<app-makingpayment (paymentHasBeenQueued)="paymentHasBeenQueued($event)" [makingPayment]=true [loan_viewed]="loan_viewed"></app-makingpayment>